'use strict';

module.exports = function () {
    // returns true
    // comment
    return true;
};



// WEBPACK FOOTER //
// ./src/index.js